import React from 'react'
import RadioIcon from "../../../assets/images/Radio.svg"
import Button from '../forms/button/Button'

export const RadioBroadcast = ({data}) => {
  return (
    <div className='flex flex-col gap-4'>
          <div className='flex justify-between items-center'>
        <h2 className='md:text-[16px] text-[#00000] font-ManropeSemibold leading-[20px] '>Radio Broadcast</h2>
            <img src={RadioIcon} alt="radio-icon" />
        </div>
        {
            data.map((broadcast, id)=>(
                <div className='flex gap-2 items-center py-4'>
                    <img src={broadcast.img} alt="event-image" className='w-[55px] h-[62px] rounded-[4px]' />
                    <div className='flex gap-2 flex-col'>
                        <h2 className='text-[12px] leading-[18px] font-ManropeSemibold'>{broadcast.name}</h2>
                        <p className={`text-primary`}>Tune In</p>
                    </div>
                </div>
            ))
        }
    </div>
  )
}
